import React, { useState, useContext, useEffect } from 'react';
import { Card, NavDropdown } from 'react-bootstrap';
import Slider from '@mui/material/Slider';
import { useWidgetContext } from '../context/DragContext';
import { AuthContext } from '../context/AuthContext';
import { useLocation } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';

function SymbolDetails() {

  const [showDropdown, setShowDropdown] = useState(false);
  const { removeWidgetFromGrid } = useWidgetContext();
  const { addWatchlist, watchlistData, deleteWatchlist, getWatchLists, symbolDetails, priceChange, currentPrice, symbolData, olChange, highPrice, lowPrice, apiProvider, thirdParyAccount, userData, baseCurencySymbol, curencySymbol, symbolDetailsLoading } = useContext(AuthContext);
  const [isOnWatchlist, setIsOnWatchlist] = useState(false);
  const [id, setId] = useState([]);
  const [name, setName] = useState("");
  const [rows, setRows] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const location = useLocation();

  const isDemoPath = location.pathname === '/demo';

  useEffect(() => {
    // console.log(symbolDetails)

    if(thirdParyAccount === 'IBKR'){
      if (symbolDetails[0] && symbolDetails[0].conid && apiProvider == 'IBKR') {
        setId(symbolDetails[0]["conid"]);
        setName(symbolDetails[0]["55"]);
        setRows([{ C: symbolDetails[0]["conid"] }]);
      }
    }
    else if(thirdParyAccount === 'etrade' || thirdParyAccount === 'coinbase'){
      setId(userData.id.toString());
      setName(symbolData);
    }
    
  }, [symbolDetails]);

  const averagePrice = priceChange?.["5d"]
    ? ((priceChange?.["5d"].end_price + priceChange?.["5d"].start_price) / 2).toFixed(2)
    : null;

  const handleToggle = (isOpen) => {
    setShowDropdown(isOpen);
  };

  const handleSvgClick = () => {
    setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    if (Array.isArray(watchlistData)) {

      const isItemInWatchlist = watchlistData.some((list) => 
        list.details.instruments.some((instrument) => instrument.fullName === symbolData)
      );
      
      setIsOnWatchlist(isItemInWatchlist);
    } else {
      setIsOnWatchlist(false);
    }
  }, [watchlistData, symbolData]);

  const handleAddClick = async () => {
    try {
      const response = await addWatchlist(thirdParyAccount, baseCurencySymbol, curencySymbol, id, name, rows);

      if (response.message === "Watchlist added successfully") {
        await getWatchLists(thirdParyAccount,userData?.integrations?.trade_account_id);
        setIsOnWatchlist(true);
        // console.log('Add Watchlist Response:', response);
      }
      else {
        console.log('failed to add to  watchlist');
      }
    } catch (error) {
      console.error('Error adding to watchlist:', error);
    }
  };

  const handleDeleteClick = async () => {
    try {
      if (Array.isArray(watchlistData)) {
        // const watchlistItem = watchlistData.find((list) => list.name === symbolData);
        const watchlistItem = watchlistData.find((list) => 
          list.details.instruments.some((instrument) => instrument.fullName === symbolData)
        );
        
        const watchlistId = watchlistItem ? watchlistItem.details.id : null; // Ensure safety
        
        console.log(watchlistId);
        

        const response = await deleteWatchlist(thirdParyAccount, watchlistId);
        // console.log(response)
        if (response.message === "Watchlist deleted successfully") {
          await getWatchLists(thirdParyAccount, userData?.integrations?.trade_account_id);
          setIsOnWatchlist(false);
          // console.log('Delete Watchlist Response:', response);
        }
        else {
          console.log('failed to add to  watchlist');
        }
      }
      
    } catch (error) {
      console.error('Error adding to watchlist:', error);
    }
  };

  const toggleMoreInfo = () => {
    setShowMore(!showMore);
  };

  const normalizeSymbolData = (data) => {
    return data.map((item) => {
      if (apiProvider == 'IBKR' && symbolDetails[0].conid) {
        // Format 1
        return {
          high: item["70"] || 0,
          low: item["71"] || 0,
          change: item["82"] || 0,
          change_percent: item["83"] || 0,
          volume: item["87"] || 0,
          last_size: item["7059"] || 0,
          open_interest: item["7085"] || 0,
          prior_close: item["7741"] || 0,
          future_open_interest: item["7697"] || 0,
          bid_price: item["84"] || 0,
          ask_price: item["86"] || 0,
          spx_delta: item["7696"] || 0,
          beta: item["7718"] || 0,
          week_high: item["7293"] || 0,
          week_low: item["7294"] || 0
        };
      } else if (apiProvider == 'polygon' && symbolDetails[0].session) {
        // console.log(data)
        // Format 2
        return {
          high: data[0].session.high || 0,
          low: data[0].session.low || 0,
          change: data[0].session.change || 0,
          change_percent: data[0].session.change_percent || 0,
          volume: data[0].session.volume || 0,
          last_size: data[0].last_trade?.size || 0,
          open_interest: data[0].open_interest || 0,
          prior_close: data[0].session.previous_close || 0,
          future_open_interest: 0,
          bid_price: data[0].last_quote?.bid || 0,
          ask_price: data[0].last_quote?.ask || 0,
          spx_delta: 0,
          beta: 0,
          week_high: 0,
          week_low: 0
        };
      } else {
        // Unknown format
        return {
          hight: 0,
          low: 0,
          change: 0,
          change_percent: 0,
          volume: 0,
          last_size: 0,
          open_interest: 0,
          prior_close: 0,
          future_open_interest: 0,
          bid_price: 0,
          ask_price: 0,
          spx_delta: 0,
          beta: 0,
          week_high: 0,
          week_low: 0
        };
      }
    });
  }
  const normalizedData = normalizeSymbolData(symbolDetails);

  const Loader = ({ width = 65 }) => (
    <Skeleton
      width={width}
      style={{ margin: "4px 2px", borderRadius: "3px" }}
      baseColor="rgba(137, 136, 137, 0.3)"
      highlightColor="rgba(176, 176, 176, 0.3)"
    />
  );

  // console.log(normalizedData)
  return (
    <Card className="main-card mt-3">
      <Card.Header className="pb-0">
        <div className="d-flex justify-content-between mt-1">
          <h2 className="medium-heading mb-0">{symbolData || 'N/A'}</h2>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              onClick={window.location.pathname !== '/demo' ? handleSvgClick : undefined}
              style={{ cursor: window.location.pathname !== '/demo' ? 'pointer' : 'default' }}
            >
              <path d="M12 13.5C11.7033 13.5 11.4133 13.412 11.1666 13.2472C10.92 13.0824 10.7277 12.8481 10.6142 12.574C10.5006 12.2999 10.4709 11.9983 10.5288 11.7074C10.5867 11.4164 10.7296 11.1491 10.9393 10.9393C11.1491 10.7296 11.4164 10.5867 11.7074 10.5288C11.9983 10.4709 12.2999 10.5006 12.574 10.6142C12.8481 10.7277 13.0824 10.92 13.2472 11.1666C13.412 11.4133 13.5 11.7033 13.5 12C13.5 12.3978 13.342 12.7794 13.0607 13.0607C12.7794 13.342 12.3978 13.5 12 13.5Z" fill="white" />
              <path d="M18.75 13.5C18.4533 13.5 18.1633 13.412 17.9166 13.2472C17.67 13.0824 17.4777 12.8481 17.3642 12.574C17.2506 12.2999 17.2209 11.9983 17.2788 11.7074C17.3367 11.4164 17.4796 11.1491 17.6893 10.9393C17.8991 10.7296 18.1664 10.5867 18.4574 10.5288C18.7483 10.4709 19.0499 10.5006 19.324 10.6142C19.5981 10.7277 19.8324 10.92 19.9972 11.1666C20.162 11.4133 20.25 11.7033 20.25 12C20.25 12.3978 20.092 12.7794 19.8107 13.0607C19.5294 13.342 19.1478 13.5 18.75 13.5Z" fill="white" />
              <path d="M5.25 13.5C4.95333 13.5 4.66332 13.412 4.41665 13.2472C4.16997 13.0824 3.97771 12.8481 3.86418 12.574C3.75065 12.2999 3.72094 11.9983 3.77882 11.7074C3.8367 11.4164 3.97956 11.1491 4.18934 10.9393C4.39912 10.7296 4.66639 10.5867 4.95737 10.5288C5.24834 10.4709 5.54994 10.5006 5.82403 10.6142C6.09812 10.7277 6.33238 10.92 6.49721 11.1666C6.66203 11.4133 6.75 11.7033 6.75 12C6.75 12.3978 6.59197 12.7794 6.31066 13.0607C6.02936 13.342 5.64783 13.5 5.25 13.5Z" fill="white" />
            </svg>
            <NavDropdown
              show={showDropdown}
              onToggle={handleToggle}
              title=""
              id="nav-dropdown"
              align="end"
              className="d-inline custom-nav-dropdown"
              style={{ display: showDropdown ? 'block' : 'none' }}
            >
              <NavDropdown.Item className="dropdown-option" onClick={() => removeWidgetFromGrid('info')}>Close Window</NavDropdown.Item>
            </NavDropdown>
          </div>
        </div>
      </Card.Header>
      <Card.Body className="pt-0 scrollbar-custom">
        <div className="d-flex justify-content-between align-items-center mt-1">
          <div className="d-flex text-success align-items-center">
            {symbolDetailsLoading ? (
              <>
                <Skeleton
                  width={80} height={30}
                  style={{ margin: "4px 2px", borderRadius: "3px" }}
                  baseColor="rgba(137, 136, 137, 0.3)"
                  highlightColor="rgba(176, 176, 176, 0.3)"
                />
                <div>
                  <Loader />
                  <Loader />
                </div>
              </>
            ):( <>
              <h1 className="large-h1 mb-0">{currentPrice?.toFixed(2) || "0"}</h1>
              <div>
                <p className={`pl-2 mb-0 symbol-details-text ${normalizedData[0]?.["change"] && normalizedData[0]?.["change_percent"] > 0 ? 'text-success' : 'text-danger'}`}>
                  {normalizedData[0]?.["change"] === "0" ? "0" : normalizedData[0]?.["change"] ? parseFloat(normalizedData[0]["change"]).toFixed(2) : "0"}
                </p>
                {/* <br /> */}
                <p className={`pl-2 mb-0 symbol-details-text ${normalizedData[0]?.["change"] && normalizedData[0]?.["change_percent"] > 0 ? 'text-success' : 'text-danger'}`}>
                  {normalizedData[0]?.["change_percent"] === "0" ? "0" : normalizedData[0]?.["change_percent"] ? parseFloat(normalizedData[0]["change_percent"]).toFixed(2) : "0"}%
                </p>
              </div>
            </>
            )}
          </div>
          <div>
            {isDemoPath || !userData?.integrations ? (
              <img src={`${process.env.PUBLIC_URL}/images/bookmark.svg`} height="28" width="24" alt="bookmark-icon" />
            ) : isOnWatchlist ? (
              <img src={`${process.env.PUBLIC_URL}/images/filled_bookmark.svg`} height="23" width="20" onClick={handleDeleteClick} alt="bookmark-icon" />
            ) : (
              <img src={`${process.env.PUBLIC_URL}/images/bookmark.svg`} onClick={handleAddClick} height="28" width="24" alt="bookmark-icon" />
            )}
          </div>
        </div>

        <div className={`row  pl-2 pr-2 ${!symbolDetailsLoading ? "mt-3" : "mt-4"}`}>
          {symbolDetailsLoading ? (
            <>
              <div className="col-6"><Loader /></div>
              <div className="col-6 text-end" style={{ paddingRight: symbolDetailsLoading ? "0" : "initial" }}>
                <Loader />
              </div>
              <div className="col-2"><Loader /></div>
              <div className="col-8 ps-4 pe-4">
                <Skeleton
                  // width={width}
                  style={{ margin: "4px 2px", borderRadius: "3px" }}
                  baseColor="rgba(137, 136, 137, 0.3)"
                  highlightColor="rgba(176, 176, 176, 0.3)"
                />
              </div>
              <div className="col-2 text-end"><Loader /></div>
            </>):(<>
              <div className="col-6 text-danger bold">{normalizedData[0]?.["low"] === "0" ? "0" : normalizedData[0]?.["low"] ? parseFloat(normalizedData[0]["low"]).toFixed(2) : "N/A"}</div>
              <div className="col-6 text-success text-end bold">{normalizedData[0]?.["high"] === "0" ? "0" : normalizedData[0]?.["high"] ? parseFloat(normalizedData[0]["high"]).toFixed(2) : "N/A"}</div>
              <div className="col-2 low-high">Low</div>
              <div className="col-8 ps-0 pe-0">
                <Slider
                  aria-label="Custom marks"
                  value={isNaN(currentPrice) ? 0 : currentPrice}
                  min={isNaN(normalizedData[0]?.["low"]) ? 0 : parseFloat(normalizedData[0]?.["low"])}
                  max={isNaN(normalizedData[0]?.["high"]) ? 1000 : parseFloat(normalizedData[0]?.["high"])}
                  step={0.01}
                  getAriaValueText={(value) => isNaN(value) ? '0' : `${value}`}
                  valueLabelDisplay="on"
                  disabled
                />
              </div>
              <div className="col-2 low-high text-end">High</div>
            </>
          )}
        </div>

        <div className={`row pl-2 pr-1 ${!symbolDetailsLoading ? "mt-2" : "mt-3"}`}>
          <div className="col-3 mt-2">
            {symbolDetailsLoading ? (
              <>
              <Loader />
              <Loader />
              </>
            ):(<>
                <span className="gray-text f-s-14">Prev. Close</span> <br />
                <span className="bold symbol-details-prev">{normalizedData[0]?.["prior_close"] === "0" ? "0" : normalizedData[0]?.["prior_close"] ? parseFloat(normalizedData[0]["prior_close"]).toFixed(2) : "N/A"}</span>
              </>
            )}
          </div>
          {apiProvider === 'IBKR' && (
            <>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">Ol</span> <br />
                <span className="bold symbol-details-prev">{normalizedData[0]?.["future_open_interest"] === "0" ? "0" : normalizedData[0]?.["future_open_interest"] ? parseFloat(normalizedData[0]["future_open_interest"]).toFixed(2) : "N/A"}</span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">Ol Chg</span> <br />
                <span className="bold symbol-details-prev">{olChange?.toFixed(2) || "N/A"}</span>
              </div>
            </>
          )}
          <div className="col-3 mt-2">
            {symbolDetailsLoading ? (
              <>
                <Loader />
                <Loader />
              </>
            ):(<>
                <span className="gray-text f-s-14">Lot Size</span> <br />
                <span className="bold symbol-details-prev">{normalizedData[0]?.["last_size"] === "0" ? "0" : normalizedData[0]?.["last_size"] ? parseFloat(normalizedData[0]["last_size"]).toFixed(2) : "N/A"}</span>
              </>
            )}
          </div>
          <div className="col-3 mt-2">
            {symbolDetailsLoading ? (
              <>
              <Loader />
              <Loader />
              </>
            ):(<>
                <span className="gray-text f-s-14">Volume</span> <br />
                <span className="bold symbol-details-prev">{normalizedData[0]?.["volume"] || "N/A"}</span>
              </>
            )}
          </div>
          <div className="col-3 mt-2">
            {symbolDetailsLoading ? (
              <>
              <Loader />
              <Loader />
              </>
            ):(<>
                <span className="gray-text f-s-14">Bid</span> <br />
                <span className="bold symbol-details-prev">{normalizedData[0]?.["bid_price"] === "0" ? "0" : normalizedData[0]?.["bid_price"] ? parseFloat(normalizedData[0]["bid_price"]).toFixed(2) : "N/A"}</span>
              </>
            )}
          </div>
          <div className="col-3 mt-2">
            {symbolDetailsLoading ? (
              <>
              <Loader />
              <Loader />
              </>
            ):(<>
                <span className="gray-text f-s-14">Ask</span> <br />
                <span className="bold symbol-details-prev">{normalizedData[0]?.["ask_price"] === "0" ? "0" : normalizedData[0]?.["ask_price"] ? parseFloat(normalizedData[0]["ask_price"]).toFixed(2) : "N/A"}</span>
              </>
            )}
          </div>
          <div className="col-3 mt-2">
            {symbolDetailsLoading ? (
              <>
              <Loader />
              <Loader />
              </>
            ):(<>
                <span className="gray-text f-s-14">Open Interest</span> <br />
                <span className="bold symbol-details-prev">{normalizedData[0]?.["open_interest"] === "0" ? "0" : normalizedData[0]?.["open_interest"] ? parseFloat(normalizedData[0]["open_interest"]).toFixed(2) : "N/A"}</span>
              </>
            )}
          </div>
          <div className="col-3 mt-2">
            {symbolDetailsLoading ? (
              <>
              <Loader />
              <Loader />
              </>
            ):(<>
                <span className="gray-text f-s-14">5 Day</span> <br />
                <span className={`bold symbol-details-prev ${priceChange?.["5d"]?.percent_change > 0 ? 'text-success' : 'text-danger'}`}>
                  {priceChange?.["5d"]?.percent_change === "0" ? "0" : priceChange?.["5d"]?.percent_change ? parseFloat(priceChange?.["5d"]?.percent_change)?.toFixed(2) : "N/A"}%
                </span>
              </>
            )}
          </div>
          {!showMore ? (
            <div className={`col-3 ${!symbolDetailsLoading ? "mt-3" : "mt-2"}`}
            style={{ cursor: 'pointer' }} onClick={toggleMoreInfo}>
              {symbolDetailsLoading ? (
                <>
                  <Loader />
                  <Loader />
                </>
              ):(<>
                  <span className="symbol-details-prev">More</span>
                  <img src={`${process.env.PUBLIC_URL}/images/down 2.svg`} alt="icon" style={{ marginLeft: '4px', marginTop: '-3px' }} />
                </>
              )}
            </div>
          ) : (
            <>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">1 Month</span> <br />
                <span className={`bold symbol-details-prev ${priceChange?.["1m"]?.percent_change > 0 ? 'text-success' : 'text-danger'}`}>
                  {priceChange?.["1m"]?.percent_change === "0" ? "0" : priceChange?.["1m"]?.percent_change ? parseFloat(priceChange?.["1m"]?.percent_change)?.toFixed(2) : "N/A"}%
                </span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">3 Month</span> <br />
                <span className={`bold symbol-details-prev ${priceChange?.["3m"]?.percent_change > 0 ? 'text-success' : 'text-danger'}`}>
                  {priceChange?.["3m"]?.percent_change === "0" ? "0" : priceChange?.["3m"]?.percent_change ? parseFloat(priceChange?.["3m"]?.percent_change)?.toFixed(2) : "N/A"}%
                </span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">1 Year</span> <br />
                <span className={`bold symbol-details-prev ${priceChange?.["1y"]?.percent_change > 0 ? 'text-success' : 'text-danger'}`}>
                  {priceChange?.["1y"]?.percent_change === "0" ? "0" : priceChange?.["1y"]?.percent_change ? parseFloat(priceChange?.["1y"]?.percent_change)?.toFixed(2) : "N/A"}%
                </span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">SPX Delta</span> <br />
                <span className="bold symbol-details-prev">{normalizedData[0]?.["spx_delta"] === "0" ? "0" : normalizedData[0]?.["spx_delta"] ? parseFloat(normalizedData[0]["spx_delta"]).toFixed(2) : "N/A"}</span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">Beta</span> <br />
                <span className="bold symbol-details-prev">{normalizedData[0]?.["beta"] === "0" ? "0" : normalizedData[0]?.["beta"] ? parseFloat(normalizedData[0]["beta"]).toFixed(2) : "N/A"}</span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">5-Day Chg</span> <br />
                <span className="bold symbol-details-prev">{averagePrice || "N/A"}</span>
              </div>
              <div className="col-3 mt-2">
                <span className="gray-text f-s-14">52-Week Range</span> <br />
                <span className="bold symbol-details-prev">
                  {normalizedData[0]?.["week_high"] || normalizedData[0]?.["week_low"]
                    ? `${normalizedData[0]?.["week_high"] === "0" ? "0" : normalizedData[0]?.["week_high"] ? parseFloat(normalizedData[0]["week_high"]).toFixed(2) : "-"} - ${normalizedData[0]?.["week_low"] === "0" ? "0" : normalizedData[0]?.["week_low"] ? parseFloat(normalizedData[0]["week_low"]).toFixed(2) : "-"
                    }`
                    : "N/A"}
                </span>
              </div>
            </>
          )}
        </div>
      </Card.Body>
    </Card>
  );
}

export default SymbolDetails;
